package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.List
import br.com.htms.inspeccaocampo.ui.kit.PortalMenuItem
import br.com.htms.inspeccaocampo.ui.kit.PortalModulo
import br.com.htms.inspeccaocampo.ui.theme.PortalCores
import br.com.htms.inspeccaocampo.ui.kit.PortalOutlinedButton
import br.com.htms.inspeccaocampo.ui.kit.PortalButton
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.material3.Button
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.ExposedDropdownMenuBox
import androidx.compose.material3.ExposedDropdownMenuDefaults
import androidx.compose.material3.FilterChip
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.data.AcompAmbAba
import br.com.htms.inspeccaocampo.data.AcompAmbMeses
import br.com.htms.inspeccaocampo.data.AcompAmbSchema
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.AppOutlinedTextField
import br.com.htms.inspeccaocampo.shared.ui.components.CampoFotoRow
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun SharedAcompanhamentoAmbientalScreen(controller: AppController) {
    val form by controller.acompAmbForm.collectAsState()
    val obrasAtivas by controller.obrasAtivas.collectAsState()
    val salvando by controller.acompAmbSalvando.collectAsState()
    val baixando by controller.acompAmbBaixando.collectAsState()
    val readOnly = form.readOnly
    val schema = AcompAmbSchema.schema(form.aba)
    val monthly = AcompAmbSchema.monthly(form.aba)
    val informative = AcompAmbSchema.informative(form.aba)

    var menuObra by remember { mutableStateOf(false) }
    var menuAno by remember { mutableStateOf(false) }
    var menuMes by remember { mutableStateOf(false) }

    LaunchedEffect(Unit) {
        controller.carregarObrasAtivas()
    }

    fun setValue(key: String, value: String) {
        controller.atualizarAcompAmbValor(key, value)
    }

    val rolagem71 = androidx.compose.foundation.lazy.rememberLazyListState()
    PortalModulo(
        titulo = "Acompanhamento Ambiental",
        itens = AcompAmbAba.entries.map { PortalMenuItem(it.name, it.rotulo, Icons.Filled.List) },
        selecionado = form.aba.name,
        onSelect = { nome ->
            AcompAmbAba.entries.firstOrNull { it.name == nome }?.let { controller.selecionarAcompAmbAba(it) }
        },
        rolavel = false
    ) { _ ->
    br.com.htms.inspeccaocampo.ui.kit.AreaRolavel(rolagem71, Modifier.fillMaxWidth().weight(1f)) {
    LazyColumn(
        state = rolagem71,
        modifier = Modifier.fillMaxSize(),
        contentPadding = PaddingValues(bottom = 24.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        item {
            Text(
                "Preencha a aba escolhida no menu, por obra e ano. Depois de salvar, o dossiê aparece no Histórico.",
                style = MaterialTheme.typography.bodyMedium,
                color = MaterialTheme.colorScheme.onSurfaceVariant
            )
        }
        item {
            br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                label = "Obra",
                opcoes = obrasAtivas.map { it.nome to it.nome },
                selecionado = form.obra,
                onSelect = { controller.atualizarAcompAmbObra(it) }
            )
        }
        item {
            br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                label = "Ano",
                opcoes = (2024..2030).map { it.toString() to it.toString() },
                selecionado = form.ano.toString(),
                onSelect = { v -> v.toIntOrNull()?.let { controller.atualizarAcompAmbAno(it) } }
            )
        }
        item {
            PortalButton(
                onClick = { controller.abrirOuCriarAcompAmbDossier() },
                enabled = form.obra.isNotBlank() && !salvando,
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(
                    if (form.dossierId.isNullOrBlank()) "Abrir / criar dossiê"
                    else "Recarregar dossiê"
                )
            }
            if (!form.dossierId.isNullOrBlank()) {
                Text(
                    "Dossiê: ${form.dossierId}",
                    style = MaterialTheme.typography.bodySmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                    modifier = Modifier.padding(top = 4.dp)
                )
            }
        }

        if (form.dossierId.isNullOrBlank()) return@LazyColumn

        if (readOnly) {
            item {
                Text(
                    "Esta aba/mês já foi salvo no servidor — somente leitura. Selecione outra aba ou mês para preencher, ou peça ao admin para alterar.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = MaterialTheme.colorScheme.error
                )
            }
        }

        if (monthly) {
            item {
                br.com.htms.inspeccaocampo.ui.kit.SeletorBusca(
                    label = "Mês",
                    opcoes = (1..12).map { it.toString() to AcompAmbMeses.rotulo(it) },
                    selecionado = form.mes.toString(),
                    onSelect = { v -> v.toIntOrNull()?.let { controller.selecionarAcompAmbMes(it) } }
                )
            }
        }

        if (schema.infoBlocks.isNotEmpty()) {
            item {
                Text(
                    if (informative) "Orientações do template (aba informativa)"
                    else "Orientações desta aba",
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.SemiBold,
                    color = MaterialTheme.colorScheme.primary
                )
            }
        }

        schema.infoBlocks.forEach { block ->
            item(key = "info-${block.title}") {
                Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                    Text(block.title, fontWeight = FontWeight.SemiBold)
                    block.lines.forEach { line ->
                        Text(
                            "• $line",
                            style = MaterialTheme.typography.bodyMedium,
                            color = MaterialTheme.colorScheme.onSurfaceVariant
                        )
                    }
                }
            }
        }

        if (schema.fields.isNotEmpty()) {
            item {
                Text(
                    if (informative) "Cabeçalho (opcional)" else "Campos",
                    fontWeight = FontWeight.SemiBold
                )
            }
            schema.fields.forEach { field ->
                item(key = "field-${field.key}") {
                    AppOutlinedTextField(
                        value = form.payload.get(field.key),
                        onValueChange = { if (!readOnly) setValue(field.key, it) },
                        readOnly = readOnly,
                        enabled = !readOnly,
                        label = { Text(field.label) },
                        keyboardOptions = if (field.type == "number") {
                            KeyboardOptions(keyboardType = KeyboardType.Decimal)
                        } else {
                            KeyboardOptions.Default
                        },
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
        }

        if (schema.gridRows.isNotEmpty()) {
            item {
                Text(
                    if (monthly) "Indicadores — ${AcompAmbMeses.rotulo(form.mes)}"
                    else "Indicadores",
                    fontWeight = FontWeight.SemiBold
                )
            }
            schema.gridRows.forEach { row ->
                item(key = "grid-${row.key}") {
                    AppOutlinedTextField(
                        value = form.payload.get(row.key),
                        onValueChange = { if (!readOnly) setValue(row.key, it) },
                        readOnly = readOnly,
                        enabled = !readOnly,
                        label = { Text(row.label) },
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            }
        }

        if (schema.photoSlots.isNotEmpty()) {
            item {
                Text(
                    "Registro fotográfico",
                    fontWeight = FontWeight.SemiBold
                )
            }
            schema.photoSlots.forEach { slot ->
                item(key = "photo-${slot.key}") {
                    val refs = form.payload.fotosDoSlot(slot.key)
                    Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                        Text(slot.label, fontWeight = FontWeight.Medium)
                        if (!readOnly) {
                            CampoFotoRow(
                                label = if (refs.isEmpty()) "Adicionar foto" else "Fotos anexadas",
                                obrigatorio = false,
                                quantidadeFotos = refs.size,
                                onTirarFoto = {
                                    if (refs.size < slot.maxPhotos) {
                                        controller.adicionarFotoAcompAmb(slot.key, fromGallery = false)
                                    }
                                },
                                onAdicionarMais = {
                                    if (refs.size < slot.maxPhotos) {
                                        controller.adicionarFotoAcompAmb(slot.key, fromGallery = false)
                                    }
                                },
                                onAbrirLista = { },
                                onGaleria = {
                                    if (refs.size < slot.maxPhotos) {
                                        controller.adicionarFotoAcompAmb(slot.key, fromGallery = true)
                                    }
                                }
                            )
                        } else {
                            Text(
                                if (refs.isEmpty()) "Nenhuma foto anexada"
                                else "${refs.size} foto(s) anexada(s)",
                                style = MaterialTheme.typography.bodyMedium,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                        if (refs.isNotEmpty() && !readOnly) {
                            refs.forEachIndexed { idx, _ ->
                                PortalOutlinedButton(
                                    onClick = { controller.removerFotoAcompAmb(slot.key, idx) },
                                    modifier = Modifier.fillMaxWidth()
                                ) { Text("Remover foto ${idx + 1}") }
                            }
                        }
                        if (!readOnly && refs.size >= slot.maxPhotos) {
                            Text(
                                "Limite de ${slot.maxPhotos} fotos neste registro.",
                                style = MaterialTheme.typography.bodySmall,
                                color = MaterialTheme.colorScheme.onSurfaceVariant
                            )
                        }
                    }
                }
            }
        }

        item {
            PortalButton(
                onClick = { controller.salvarAcompAmbAtual() },
                enabled = !salvando && !readOnly && !form.dossierId.isNullOrBlank() &&
                    (schema.fields.isNotEmpty() || schema.gridRows.isNotEmpty()),
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(if (salvando) "Salvando…" else "Salvar aba atual")
            }
        }
        item {
            PortalOutlinedButton(
                onClick = { controller.baixarAcompAmbExcel() },
                enabled = !baixando && !form.dossierId.isNullOrBlank(),
                modifier = Modifier.fillMaxWidth()
            ) {
                Text(if (baixando) "Gerando Excel…" else "Baixar Excel")
            }
        }
    }
    }
    }
}
